export default __webpack_public_path__ + "static/media/passwordwallettop1.1ab2f01c.png";